export default __webpack_public_path__ + "static/media/document-logo-3.807631c7.svg";